// extracted by mini-css-extract-plugin
module.exports = {"mpproduct-badge":"MagePlazaProductBadge_mpproduct-badge__alGHU"};